import React from 'react';

const FounderNote = () => {
  return (
    <section className="py-16 px-4 sm:px-6 lg:px-8 bg-slate-900">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        {/* Left Side: Founder's Image */}
        <div className="relative rounded-lg overflow-hidden shadow-lg h-96">
          <img 
            src="assets/Founder 2.png" 
            alt="Founder" 
            className="w-full h-full object-cover rounded-lg"
          />
        </div>
        
        {/* Right Side: Founder's Message */}
        <div>
          <h2 className="text-4xl font-bold text-white mb-4 leading-tight">
            A message from our <span className="text-amber-400">Founder</span>
          </h2>
          <p className="text-slate-400 mb-6">
            "At Quick Wheels, our journey began with a simple idea: to make car rental not just a transaction, but an experience. We believe that every journey, big or small, deserves a reliable and extraordinary start. This vision drives us to constantly innovate and provide you with a fleet of cars that are more than just vehicles; they are companions for your adventure."
          </p>
          <div className="border-l-4 border-amber-400 pl-4">
            <h3 className="text-xl font-bold text-white">John Doe</h3>
            <p className="text-slate-400">Founder & CEO, Quick Wheels</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FounderNote;